// @flow
import { SeaLogActionTypes } from './constants';

const INIT_STATE = {
    seaLog: {},
    listaSeaLogs: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {},
};

type SeaLogAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { seaLog?: {} | null, listaSeaLogs?: [] | null, loading?: boolean, +value ?: boolean };

const SeaLog = (state: State = INIT_STATE, action: SeaLogAction): any => {
    // console.log(action);
    switch (action.type) {
        case SeaLogActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SeaLogActionTypes.GET_SEA_LOG: {
                    return {
                        ...state,
                        seaLog: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeaLogActionTypes.LIST_SEA_LOGS: {
                    return {
                        ...state,
                        listaSeaLogs: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeaLogActionTypes.ADD_SEA_LOG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaLogActionTypes.UPDATE_SEA_LOG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaLogActionTypes.DELETE_SEA_LOG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeaLogActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SeaLogActionTypes.GET_SEA_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        seaLog: {},
                        loading: false,
                    };
                }
                case SeaLogActionTypes.LIST_SEA_LOGS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaSeaLogs: [],
                        loading: false,
                    };
                }
                case SeaLogActionTypes.ADD_SEA_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaLogActionTypes.UPDATE_SEA_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaLogActionTypes.DELETE_SEA_LOG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeaLogActionTypes.GET_SEA_LOG:
            return { ...state, error: false, loading: true };
        case SeaLogActionTypes.LIST_SEA_LOGS:
            return { ...state, error: false, loading: true };
        case SeaLogActionTypes.ADD_SEA_LOG:
            return { ...state, error: false, loading: true };
        case SeaLogActionTypes.UPDATE_SEA_LOG:
            return { ...state, error: false, loading: true };
        case SeaLogActionTypes.DELETE_SEA_LOG:
            return { ...state, error: false, loading: true };
        case SeaLogActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                seaLog: {},
                listaSeaLogs: [],
                formSubmited: false
            };
        case SeaLogActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default SeaLog;
